import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/user/index.js'), 'user/index.js')
  resolveStoreModules(require('../store/settings/index.js'), 'settings/index.js')
  resolveStoreModules(require('../store/product/index.js'), 'product/index.js')
  resolveStoreModules(require('../store/help/index.js'), 'help/index.js')
  resolveStoreModules(require('../store/content/index.js'), 'content/index.js')
  resolveStoreModules(require('../store/checkout/index.js'), 'checkout/index.js')
  resolveStoreModules(require('../store/categoryListings/index.js'), 'categoryListings/index.js')
  resolveStoreModules(require('../store/basket/index.js'), 'basket/index.js')
  resolveStoreModules(require('../store/basket/actions.js'), 'basket/actions.js')
  resolveStoreModules(require('../store/basket/getters.js'), 'basket/getters.js')
  resolveStoreModules(require('../store/basket/initialState.js'), 'basket/initialState.js')
  resolveStoreModules(require('../store/basket/mutations.js'), 'basket/mutations.js')
  resolveStoreModules(require('../store/categoryListings/getters.js'), 'categoryListings/getters.js')
  resolveStoreModules(require('../store/categoryListings/mutations.js'), 'categoryListings/mutations.js')
  resolveStoreModules(require('../store/categoryListings/state.js'), 'categoryListings/state.js')
  resolveStoreModules(require('../store/checkout/actions.js'), 'checkout/actions.js')
  resolveStoreModules(require('../store/checkout/getters.js'), 'checkout/getters.js')
  resolveStoreModules(require('../store/checkout/initialState.js'), 'checkout/initialState.js')
  resolveStoreModules(require('../store/checkout/mutations.js'), 'checkout/mutations.js')
  resolveStoreModules(require('../store/content/actions.js'), 'content/actions.js')
  resolveStoreModules(require('../store/content/getters.js'), 'content/getters.js')
  resolveStoreModules(require('../store/content/mutations.js'), 'content/mutations.js')
  resolveStoreModules(require('../store/content/state.js'), 'content/state.js')
  resolveStoreModules(require('../store/help/actions.js'), 'help/actions.js')
  resolveStoreModules(require('../store/help/getters.js'), 'help/getters.js')
  resolveStoreModules(require('../store/help/mutations.js'), 'help/mutations.js')
  resolveStoreModules(require('../store/help/state.js'), 'help/state.js')
  resolveStoreModules(require('../store/product/actions.js'), 'product/actions.js')
  resolveStoreModules(require('../store/product/getters.js'), 'product/getters.js')
  resolveStoreModules(require('../store/product/mutations.js'), 'product/mutations.js')
  resolveStoreModules(require('../store/product/state.js'), 'product/state.js')
  resolveStoreModules(require('../store/settings/actions.js'), 'settings/actions.js')
  resolveStoreModules(require('../store/settings/getters.js'), 'settings/getters.js')
  resolveStoreModules(require('../store/settings/mutations.js'), 'settings/mutations.js')
  resolveStoreModules(require('../store/settings/state.js'), 'settings/state.js')
  resolveStoreModules(require('../store/user/actions.js'), 'user/actions.js')
  resolveStoreModules(require('../store/user/getters.js'), 'user/getters.js')
  resolveStoreModules(require('../store/user/initialState.js'), 'user/initialState.js')
  resolveStoreModules(require('../store/user/mutations.js'), 'user/mutations.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
